import Auth from '@/Auth.js';

export default (to, from, next) => {
  Auth.setItem('last_route', from.path)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Auth.isLogged()) {
      next({
        path: '/auth/login'
      })
    } else {
      next()
    }
  }

  if (to.matched.some(record => record.meta.requiresFullAdmin)) {
    const user = JSON.parse(localStorage.getItem('user'))
    if (!user || user.email !== 'admin@admin.com.br') {
      next({
        path: '/cidade'
      })
      return
    }
  }

  if (to.matched.some(record => record.meta.requiresNoAuth)) {
    if (Auth.isLogged()) {
      next({
        path: '/cidade'
      })
    } else {
      next()
    }
  }
  if (to.matched.some(record => record.meta.verifyVisibleRelatorio)) {
    const user = JSON.parse(localStorage.getItem("user"))
    const relatorioAdm = JSON.parse(user.grupo.relatorioAdm) || [];

    if (relatorioAdm.filter(item => item == to.params.relatorioRoute).length === 0 && user.email !== "admin@admin.com.br") {
      next({
        path: '/cidade'
      })
    } else {
      next()
    }
  }
  else {
    next()
  }
}
